/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: cDS26z8R0NcM

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicLoginFormResources.module.css"; // plasmic-import: cDS26z8R0NcM/css

createPlasmicElementProxy;

export type PlasmicLoginFormResources__VariantMembers = {};
export type PlasmicLoginFormResources__VariantsArgs = {};
type VariantPropType = keyof PlasmicLoginFormResources__VariantsArgs;
export const PlasmicLoginFormResources__VariantProps =
  new Array<VariantPropType>();

export type PlasmicLoginFormResources__ArgsType = {};
type ArgPropType = keyof PlasmicLoginFormResources__ArgsType;
export const PlasmicLoginFormResources__ArgProps = new Array<ArgPropType>();

export type PlasmicLoginFormResources__OverridesType = {
  resources?: Flex__<"div">;
  accessibility?: Flex__<"div">;
  divider?: Flex__<"div">;
  privacyPolicy?: Flex__<"div">;
  divider2?: Flex__<"div">;
  compliance?: Flex__<"div">;
};

export interface DefaultLoginFormResourcesProps {
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicLoginFormResources__RenderFunc(props: {
  variants: PlasmicLoginFormResources__VariantsArgs;
  args: PlasmicLoginFormResources__ArgsType;
  overrides: PlasmicLoginFormResources__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"resources"}
      data-plasmic-override={overrides.resources}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_bvRZj1oZhhFBeMnkX2LkQu",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.resources
      )}
    >
      <div
        data-plasmic-name={"accessibility"}
        data-plasmic-override={overrides.accessibility}
        aria-label={"Accessibility Statement"}
        className={classNames("all", "__wab_text", sty.accessibility)}
        title={"Accessibility Statement"}
      >
        <React.Fragment>
          <React.Fragment>{""}</React.Fragment>
          {
            <PlasmicLink__
              className={classNames(
                "all",
                "a",
                "a__bvRZj",
                "__wab_text",
                "plasmic_default__inline",
                sty.link__ryei7
              )}
              component={Link}
              href={`/m/accessibility-statement`}
              legacyBehavior={false}
              platform={"nextjs"}
            >
              {"Accessibility Statement"}
            </PlasmicLink__>
          }
          <React.Fragment>{""}</React.Fragment>
        </React.Fragment>
      </div>
      {(hasVariant(globalVariants, "mobile", "mobileXSmall") ? false : true) ? (
        <div
          data-plasmic-name={"divider"}
          data-plasmic-override={overrides.divider}
          className={classNames("all", sty.divider)}
        />
      ) : null}
      <div
        data-plasmic-name={"privacyPolicy"}
        data-plasmic-override={overrides.privacyPolicy}
        aria-label={"Privacy Policy"}
        className={classNames("all", "__wab_text", sty.privacyPolicy, ``)}
        title={"Privacy Policy"}
      >
        <React.Fragment>
          <React.Fragment>{""}</React.Fragment>
          {
            <PlasmicLink__
              className={classNames(
                "all",
                "a",
                "a__bvRZj",
                "__wab_text",
                "plasmic_default__inline",
                sty.link__eVQn
              )}
              component={Link}
              href={`/m/privacy-policy`}
              legacyBehavior={false}
              platform={"nextjs"}
            >
              {"Privacy Policy"}
            </PlasmicLink__>
          }
          <React.Fragment>{""}</React.Fragment>
        </React.Fragment>
      </div>
      {(hasVariant(globalVariants, "mobile", "mobileXSmall") ? false : true) ? (
        <div
          data-plasmic-name={"divider2"}
          data-plasmic-override={overrides.divider2}
          className={classNames("all", sty.divider2)}
        />
      ) : null}
      <div
        data-plasmic-name={"compliance"}
        data-plasmic-override={overrides.compliance}
        aria-label={"Compliance & Certifications"}
        className={classNames("all", "__wab_text", sty.compliance, ``)}
        title={"Compliance & Certifications"}
      >
        <React.Fragment>
          <React.Fragment>{""}</React.Fragment>
          {
            <PlasmicLink__
              className={classNames(
                "all",
                "a",
                "a__bvRZj",
                "__wab_text",
                "plasmic_default__inline",
                sty.link__zdsG
              )}
              component={Link}
              href={`/m/compliance-and-certifications`}
              legacyBehavior={false}
              platform={"nextjs"}
            >
              <React.Fragment>{"Compliance & Certifications"}</React.Fragment>
            </PlasmicLink__>
          }
          <React.Fragment>{""}</React.Fragment>
        </React.Fragment>
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  resources: [
    "resources",
    "accessibility",
    "divider",
    "privacyPolicy",
    "divider2",
    "compliance"
  ],
  accessibility: ["accessibility"],
  divider: ["divider"],
  privacyPolicy: ["privacyPolicy"],
  divider2: ["divider2"],
  compliance: ["compliance"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  resources: "div";
  accessibility: "div";
  divider: "div";
  privacyPolicy: "div";
  divider2: "div";
  compliance: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicLoginFormResources__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicLoginFormResources__VariantsArgs;
    args?: PlasmicLoginFormResources__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicLoginFormResources__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicLoginFormResources__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicLoginFormResources__ArgProps,
          internalVariantPropNames: PlasmicLoginFormResources__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicLoginFormResources__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "resources") {
    func.displayName = "PlasmicLoginFormResources";
  } else {
    func.displayName = `PlasmicLoginFormResources.${nodeName}`;
  }
  return func;
}

export const PlasmicLoginFormResources = Object.assign(
  // Top-level PlasmicLoginFormResources renders the root element
  makeNodeComponent("resources"),
  {
    // Helper components rendering sub-elements
    accessibility: makeNodeComponent("accessibility"),
    divider: makeNodeComponent("divider"),
    privacyPolicy: makeNodeComponent("privacyPolicy"),
    divider2: makeNodeComponent("divider2"),
    compliance: makeNodeComponent("compliance"),

    // Metadata about props expected for PlasmicLoginFormResources
    internalVariantProps: PlasmicLoginFormResources__VariantProps,
    internalArgProps: PlasmicLoginFormResources__ArgProps
  }
);

export default PlasmicLoginFormResources;
/* prettier-ignore-end */
